import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import DuplicatePreviewItemTaxonomy from './PreviewItemTaxonomy';

import ErrorBoundary from '../../ErrorBoundary';

const DuplicatePreviewItemTaxonomies = ({ taxonomies, file }) => {
  if (!file.terms || file.terms.length === 0) {
    return null;
  }

  return (
    <ErrorBoundary>
      <li className="duplicated-preview-detail">
        {taxonomies.map(taxonomy => (
          <DuplicatePreviewItemTaxonomy
            key={`taxonomy-${taxonomy.id}`}
            taxonomy={taxonomy}
            values={file.terms.filter(t => (t.taxonomy_id === taxonomy.id))}
          />
        ))}
      </li>
    </ErrorBoundary>
  );
};

const mapStateToProps = state => ({
  taxonomies: state.Metadata.taxonomies,
});

DuplicatePreviewItemTaxonomies.propTypes = {
  taxonomies: PropTypes.array.isRequired,
  file: PropTypes.object.isRequired,
};

export default connect(mapStateToProps)(DuplicatePreviewItemTaxonomies);
